import React from 'react';
import { Link } from 'react-router-dom';

import { ROOT } from 'src/constants/routes';
import { Socials } from 'src/components/common/Socials';
import * as analytics from 'src/utils/analytics';

import css from './Footer.module.scss';

const texts = {
  searchAgain: 'חפשו מחדש',
  shareLabel: 'שתפו:',
  disclaimer:
    'הרשימה כוללת מבצעים רחבי היקף בלבד ואינה כוללת מבצעים מיוחדים, מבצעים שנערכו במהלך מלחמה, אירועים ביטחוניים פנים-ישראליים ואת המערכה ברצועת הביטחון 2000-1982',
};

export const Footer = () => {
  const onReSearchClick = () => {
    analytics.onReSearchClick();
  };

  return (
    <footer className={css.footer}>
      <Link className={css.searchAgain} to={ROOT} onClick={onReSearchClick}>
        {texts.searchAgain}
      </Link>

      <p className={css.disclaimer}>{texts.disclaimer}</p>
    </footer>
  );
};

export default Footer;
